import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CommitteeTokenService } from '../services/committee-token.service';

/**
 * Guard สำหรับ committee zone — ต้องมี session token ที่ยังไม่หมดอายุ
 * ถ้าไม่มี/หมดอายุ → เด้งไปหน้า claim (แจ้งให้ใช้ลิงก์จากอีเมลใหม่)
 */
export const committeeAuthGuard: CanActivateFn = () => {
  const tokenSvc = inject(CommitteeTokenService);
  const router = inject(Router);

  if (tokenSvc.isValid()) return true;
  tokenSvc.clear();
  return router.createUrlTree(['/committee/claim'], { queryParams: { expired: 1 } });
};
